// extracted by mini-css-extract-plugin
module.exports = {"folderName":"DetaillsFolderNames_folderName__IjA5N"};